import { render, staticRenderFns } from "./giveFeedback.vue?vue&type=template&id=6f39b7be"
import script from "./giveFeedback.vue?vue&type=script&lang=js"
export * from "./giveFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports